import {
    Avatar,
    Badge, Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Popover,
    Typography
} from "@mui/material";
import React, {useEffect, useState} from 'react'
import '../styles/App.css';
import {
    AccountCircle,
    AdminPanelSettings,
    Cloud,
    Dashboard,
    Notifications,
    ShoppingCart,
    ViewList
} from "@mui/icons-material";
import {Menu as MenuIcon} from '@mui/icons-material'
import {logoutUser, markAllNotificationsAsRead} from "../services/usersManager";
import {getFileUrl} from "../services/courseManager";
import i18n from "../config/i18n";
import {useTranslation} from "react-i18next";
import {useUser} from "../context/UserProvider";
import {Link, useLocation, useNavigate} from "react-router-dom";
import { Drawer } from "@mui/material";



let query = false;
export default function Header(props) {

    let [badge, setBadge] = useState(0);

    let [anchorEl, setAnchorEl] = useState(null);

    const [popAnchorEl, setPopAnchorEl] = React.useState(null);

    const [userSettings, setUserSettings] = useState({})

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const [notificationsOpen, setNotificationsOpen] = useState(false)

    const {user, notifications, refreshUser, settings, setNotifications} = useUser();

    const [drawerUserMenuAnchor, setDrawerUserMenuAnchor] = useState(null);

    const navigate = useNavigate();
    console.log(navigate)

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const handlePopClose = () => {
        setPopAnchorEl(null);
    };
    const {t} = useTranslation();
    const location = useLocation();

    const openPop = Boolean(popAnchorEl);
    const id = openPop ? 'simple-popover' : undefined;
    const open = Boolean(anchorEl);
    let allRead = true;
    if (notifications) {
        notifications.forEach((notification) => {
            if (notification && notification.isread.read === false && allRead === true) {
                allRead = false;
            }
        })
    }

    const handlePopClick = (event) => {
        setPopAnchorEl(event.currentTarget);
        if (!allRead) {
            markAllNotificationsAsRead().then(r => {
                if (r) {
                    let marked = notifications.map((notification) => {
                        console.log(notification)
                        if (notification) {
                            notification.isread.read = true;
                        }
                        return notification
                    })
                    console.log(marked)
                    setNotifications(marked)
                }
            });
        }
    };

    function formatTimestamp(timestamp) {
        const now = new Date();
        const timestampDate = new Date(timestamp)
        const timeDiff = now - timestampDate;
        const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60));

        if (hoursDiff < 24) {
            if (hoursDiff > 0) {
                return t("fromDiffHrsAgo", {val: hoursDiff});
            } else {
                return t("justNow");
            }
        } else {
            return timestampDate.toLocaleString(settings.siteLang, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }); // Formats to 'MM/DD/YYYY, HH:MM:SS AM/PM'
        }
    }

    let cartItems = JSON.parse(localStorage.getItem("cart") ? localStorage.getItem("cart") : "[]")
    if (badge !== cartItems.length) {
        setBadge(cartItems.length);
    }

    useEffect(() => {
        if (settings) {
            document.title = settings.siteName;
            if (settings.siteLogo) {
                let link = document.querySelector("link[rel~='icon']");
                link.href = getFileUrl(settings.siteLogo);
            }
            setUserSettings(user ? user.settings : undefined)
        }
    }, [settings]);


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const signOut = () => {
        setIsDrawerOpen(false);
        setAnchorEl(null);
        logoutUser(function () {
            refreshUser()
            navigate("/sign-in")
        })
    };
    const localStore = localStorage.setItem;

    localStorage.setItem = function (key, value) {
        const event = new Event('localUpdated');
        event.key = key;
        event.value = value;

        document.dispatchEvent(event);
        localStore.apply(this, arguments);
    };

    const localStoreHandler = function (e) {
        if (e.key === "cart") {
            setBadge(JSON.parse(e.value ? e.value : "[]").length)
        }
    };

    document.addEventListener("localUpdated", localStoreHandler, false);
    console.log(props.home)
console.log((location.pathname.toLowerCase() === "/" || location.pathname.toLowerCase().match(/^\/courses\/\d+$/) || location.pathname.toLowerCase().match(/^\/services\/\d+$/) || location.pathname.toLowerCase() === "/sign-in" || location.pathname.toLowerCase() === "/sign-up") && !!props.home);
    if (!settings) {
        return (<div></div>);
    } else {
        return (<div style={{
                background: !!!props.home ? settings.themeColor : "none",
                borderBottomRightRadius: !!!props.home ? "20px" : 0,
                borderBottomLeftRadius: !!!props.home ? "20px" : 0,
                display: ((location.pathname.toLowerCase() === "/" || location.pathname.toLowerCase().match(/^\/courses\/\d+$/) || location.pathname.toLowerCase().match(/^\/services\/\d+$/) || location.pathname.toLowerCase() === "/sign-in" || location.pathname.toLowerCase() === "/sign-up") && !props.home) ? "none" : "block"
            }}>
                <div className={"header"} style={{
                    zIndex: "100",
                    position: "relative",
                    direction: i18n.dir(settings.siteLang),
                    paddingTop: isMobile ? (user ? "40px" : "32px") : "10px",
                    paddingBottom: isMobile ? '40px' : '10px'
                }}>

                    {isMobile ? (
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ position: 'absolute', right: 16, top: 16 }}
                            onClick={() => setIsDrawerOpen(true)}
                        >
                            <MenuIcon sx={{ color: 'white' }} />
                        </IconButton>
                    ) : ( user ? (<div style={i18n.dir(settings.siteLang) === "rtl" ? {
                            position: "absolute",
                            left: 0,
                            margin: "16px"
                        } : {
                            position: "absolute",
                            right: 0,
                            margin: "16px"
                        }}><Badge invisible={allRead} anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }} color="error" variant="dot">
                            <IconButton onClick={handlePopClick}>
                                <Notifications sx={{width: 35, height: 35}} style={{color: "white"}}/>
                            </IconButton>
                        </Badge><Popover
                            id={id}
                            open={openPop}
                            anchorEl={popAnchorEl}
                            onClose={handlePopClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            style={{textAlign: "center"}}
                        >
                            {notifications && notifications.length > 0 ?
                                <List sx={{width: '100%', minWidth: 360, bgcolor: 'background.paper'}}>
                                    {notifications ? (notifications.slice(0, Math.min(6, notifications.length))).map((notification) => (
                                        <ListItemButton onClick={() => {
                                            if (notification.link) {
                                                navigate(notification.link);
                                            }
                                        }}><ListItem>
                                            <ListItemText primary={notification.title}
                                                          secondary={notification.message + " ( " + formatTimestamp(notification.timestamp) + " )"}/>
                                        </ListItem></ListItemButton>)) : <div></div>
                                    }
                                </List> : <Typography variant={"h6"}
                                                      style={{
                                                          textAlign: "center",
                                                          padding: "20px"
                                                      }}>{t("noNotifications")}</Typography>}
                            <Button style={{width: "100%"}} onClick={() => {
                                setNotificationsOpen(true)
                            }}>{t("viewAllNotifications")}</Button>
                        </Popover><IconButton onClick={handleClick}> <Avatar style={{
                            background: "white",
                            color: props.color ? props.color : (settings ? settings["themeColor"] : "#FFFFFF")
                        }} sx={{
                            width: 56,
                            height: 56
                        }}> {!user.profilephoto || !user.profilephoto.length ? user.name.substring(0, 1) : (
                            <img style={{width: "100%", height: "100%", objectFit: "cover"}}
                                 src={getFileUrl(user.profilephoto)}></img>)}</Avatar>
                        </IconButton></div>) :
                        <div style={{marginBottom: "38px"}}>
                            <Link className={"menu-item menu-item-selected sign-in"}
                                  style={i18n.dir(settings.siteLang) === "rtl" ? {
                                      position: "absolute",
                                      left: "120px", margin: "10px"
                                  } : {
                                      position: "absolute",
                                      right: "120px",
                                      margin: "10px"
                                  }}
                                  to={"/sign-in"}>تسجيل الدخول</Link>
                            <Link to="/sign-Up" style={i18n.dir(settings.siteLang) === "rtl" ? {
                                position: "absolute",
                                left: "12px"
                            } : {position: "absolute", right: "12px"}}>
                                <Button variant="contained" style={{
                                    marginLeft: "10px",
                                    borderRadius: "30px",
                                    boxShadow: "none",
                                    backgroundColor: "white",
                                    color: props.color ? props.color : (settings ? settings["themeColor"] : "#FFFFFF")
                                }}>إنشاء حساب</Button>
                            </Link></div>)}
                    {!isMobile ? (
                        <div className="menu-items">
                            <Link
                                to="/"
                                className={`menu-item ${location.pathname.toLowerCase() === "/" ? "menu-item-selected" : "menu-item-unselected"}`}
                            >
                                {t("home")}
                            </Link>

                            <Link
                                to="/courses"
                                className={`menu-item ${location.pathname.toLowerCase() === "/courses" ? "menu-item-selected" : "menu-item-unselected"}`}
                            >
                                {t("courses")}
                            </Link>

                            {settings.blogVisible && (
                                <Link
                                    to="/blog"
                                    className={`menu-item ${location.pathname.toLowerCase() === "/blog" ? "menu-item-selected" : "menu-item-unselected"}`}
                                >
                                    {t("blog")}
                                </Link>
                            )}

                            {settings.servicesVisible && (
                                <Link
                                    to="/services"
                                    className={`menu-item ${location.pathname.toLowerCase() === "/services" ? "menu-item-selected" : "menu-item-unselected"}`}
                                >
                                    {t("services")}
                                </Link>
                            )}

                            {settings.aboutVisible && (
                                <Link
                                    to="/about"
                                    className={`menu-item ${location.pathname.toLowerCase() === "/about" ? "menu-item-selected" : "menu-item-unselected"}`}
                                >
                                    {t("about")}
                                </Link>
                            )}
                        </div>
                    ) : (
                        <div></div>
                    )}

                    <Avatar onClick={() => {
                        if (window.location.pathname.toLowerCase() !== "/") {
                            navigate("/")
                        }
                    }}
                            sx={{
                                bgcolor: "white",
                                width: 56,
                                height: 56,
                                margin: "10px",
                                boxShadow: "0px 2px 4px #c6c6c6",
                                position: "absolute"
                            }}
                            style={i18n.dir(settings.siteLang) === "rtl" ? {right: "12px"} : {left: "12px"}}>{!settings.siteLogo && settings.siteLogo === "" ?
                        <Cloud
                            style={{color: props.color ? props.color : (settings ? settings["themeColor"] : "#FFFFFF")}}/> :
                        <img style={{width: "60px", height: "60px"}}
                             src={getFileUrl(settings.siteLogo)}></img>}</Avatar>

                    {props.cart && user ?
                        <Link to={"/cart"}>
                            <Badge
                                style={i18n.dir(settings.siteLang) === "rtl" ? {position: "absolute", right: "90px"} : {
                                    left: "90px",
                                    position: "absolute"
                                }} badgeContent={badge} color="primary"><IconButton
                                sx={{color: "white", marginTop: "-17px"}}
                                aria-label="add to shopping cart">
                                <ShoppingCart/>
                            </IconButton></Badge></Link> : ""}
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        {user && (user.role.role === "admin" || user.role.role === "owner") ? <div><MenuItem
                            onClick={() => navigate("/admin")}> <ListItemIcon>
                            <AdminPanelSettings fontSize="small"/>
                        </ListItemIcon>{t("admin")}</MenuItem>
                            <Divider/></div> : ""}
                        <MenuItem onClick={() => navigate("/profile")}> <ListItemIcon>
                            <AccountCircle fontSize="small"/>
                        </ListItemIcon>{t("account")}</MenuItem>
                        <MenuItem onClick={() => navigate("/dashboard")}><ListItemIcon>
                            <Dashboard fontSize="small"/>
                        </ListItemIcon>{t("dashboard")}</MenuItem>
                        <MenuItem onClick={() => navigate("/users/me/scores")}><ListItemIcon>
                            <ViewList fontSize="small"/>
                        </ListItemIcon>{t("scores")}</MenuItem>
                        <Divider/>
                        <MenuItem onClick={signOut}>{t("signOut")}</MenuItem>
                    </Menu>
                    <Dialog open={notificationsOpen}>
                        <DialogTitle>{t("notifications")}</DialogTitle>
                        <DialogContent dividers>
                            {notifications && notifications.length > 0 ?
                                <List sx={{width: '100%', minWidth: 360, bgcolor: 'background.paper'}}>
                                    {notifications ? notifications.map((notification) => (
                                        <ListItemButton onClick={() => {
                                            if (notification.link) {
                                                navigate(notification.link);
                                            }
                                        }}><ListItem>
                                            <ListItemIcon>
                                                <Notifications/>
                                            </ListItemIcon>
                                            <ListItemText primary={notification.title}
                                                          secondary={notification.message + " ( " + formatTimestamp(notification.timestamp) + " )"}/>
                                        </ListItem></ListItemButton>)) : <div></div>
                                    }
                                </List> : <Typography variant={"h6"} style={{
                                    textAlign: "center",
                                    padding: "20px"
                                }}>{t("noNotifications")}</Typography>}
                        </DialogContent>
                        <DialogActions><Button
                            onClick={() => setNotificationsOpen(false)}>{t("close")}</Button></DialogActions>
                    </Dialog>
                    <Drawer
                        anchor="right"
                        open={isDrawerOpen}
                        ModalProps={{
                            disableScrollLock: true // Add this line
                        }}
                        onClose={() => setIsDrawerOpen(false)}
                    >
                        <Box
                            sx={{ width: 250, height: '100%' }}
                            role="presentation"
                        >
                            {/* Header with logo and site name */}
                            <Box sx={{ p: 2, display: 'flex', alignItems: 'center' }} style={{direction: i18n.dir(settings.siteLang)}}>
                                <Avatar
                                    sx={{ width: 40, height: 40 }}
                                    src={settings.siteLogo ? getFileUrl(settings.siteLogo) : undefined}
                                >
                                    {!settings.siteLogo && <Cloud />}
                                </Avatar>
                                <Typography variant="h6" sx={{ ml: 1, mr: 1 }}>
                                    {settings.siteName}
                                </Typography>
                            </Box>

                            <Divider/>
                            {/* Navigation links with dividers */}
                            <List divider>
                                <ListItem button component={Link} to="/" onClick={() => setIsDrawerOpen(false)}>
                                    <ListItemText primary={t("home")} />
                                </ListItem>
                                <ListItem button component={Link} to="/courses" onClick={() => setIsDrawerOpen(false)}>
                                    <ListItemText primary={t("courses")} />
                                </ListItem>
                                {settings.blogVisible && (
                                    <ListItem button component={Link} to="/blog" onClick={() => setIsDrawerOpen(false)}>
                                        <ListItemText primary={t("blog")} />
                                    </ListItem>
                                )}
                                {settings.servicesVisible && (
                                    <ListItem button component={Link} to="/services" onClick={() => setIsDrawerOpen(false)}>
                                        <ListItemText primary={t("services")} />
                                    </ListItem>
                                )}
                                {settings.aboutVisible && (
                                    <ListItem button component={Link} to="/about" onClick={() => setIsDrawerOpen(false)}>
                                        <ListItemText primary={t("about")} />
                                    </ListItem>
                                )}
                            </List>

                            {/* Bottom section */}
                            <Box sx={{ position: 'absolute', bottom: 0, width: '100%', p: 2 }}>
                                {user ? (
                                    <>
                                        {/* Notifications button with badge */}
                                        <ListItemButton onClick={() => setNotificationsOpen(true)}>
                                            <ListItemIcon>
                                                <Badge color="error" variant="dot" invisible={allRead}>
                                                    <Notifications />
                                                </Badge>
                                            </ListItemIcon>
                                            <ListItemText primary={t("notifications")} />
                                        </ListItemButton>
                                        <Divider />

                                        {/* User profile section */}
                                        <ListItemButton onClick={(e) => setDrawerUserMenuAnchor(e.currentTarget)}>
                                            <ListItemIcon>
                                                <Avatar>
                                                    {!user.profilephoto || !user.profilephoto.length
                                                        ? user.name.substring(0, 1)
                                                        : <img src={getFileUrl(user.profilephoto)} alt="profile" style={{ width: '100%', height: '100%' }} />
                                                    }
                                                </Avatar>
                                            </ListItemIcon>
                                            <ListItemText primary={user.name} />
                                        </ListItemButton>

                                        {/* User menu */}
                                        <Menu
                                            anchorEl={drawerUserMenuAnchor}
                                            open={Boolean(drawerUserMenuAnchor)}
                                            onClose={() => setDrawerUserMenuAnchor(null)}
                                        >
                                            {user.role.role === "admin" || user.role.role === "owner" && (
                                                <>
                                                    <MenuItem onClick={() => {setIsDrawerOpen(false);navigate("/admin"); }}>
                                                        <ListItemIcon><AdminPanelSettings fontSize="small"/></ListItemIcon>
                                                        {t("admin")}
                                                    </MenuItem>
                                                    <Divider />
                                                </>
                                            )}
                                            <MenuItem onClick={() => {setIsDrawerOpen(false);navigate("/profile")}}>
                                                <ListItemIcon><AccountCircle fontSize="small"/></ListItemIcon>
                                                {t("account")}
                                            </MenuItem>
                                            <MenuItem onClick={() => {setIsDrawerOpen(false);navigate("/dashboard")}}>
                                                <ListItemIcon><Dashboard fontSize="small"/></ListItemIcon>
                                                {t("dashboard")}
                                            </MenuItem>
                                            <MenuItem onClick={() => navigate("/users/me/scores")}><ListItemIcon>
                                                <ViewList fontSize="small"/>
                                            </ListItemIcon>{t("scores")}</MenuItem>
                                            <Divider />
                                            <MenuItem onClick={signOut}>
                                                {t("signOut")}
                                            </MenuItem>
                                        </Menu>
                                    </>
                                ) : (
                                    <div>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        component={Link}
                                        to="/sign-up"
                                        onClick={() => setIsDrawerOpen(false)}
                                    >
                                        {t("signUp")}
                                    </Button>
                                        <Button
                                            fullWidth
                                            sx={{mt: 2}}
                                            variant="outlined"
                                            component={Link}
                                            to="/sign-in"
                                            onClick={() => setIsDrawerOpen(false)}
                                        >
                                            {t("signIn")}
                                        </Button>
                                    </div>
                                )}
                            </Box>
                        </Box>
                    </Drawer>
                </div>
            </div>
        )
    }
}
